import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyStart: {
        id: 'policycommon.component.policy.Policy Start',
        defaultMessage: 'Policy Start',
    },
    PolicyExpiration: {
        id: 'policycommon.component.policy.Policy Expiration',
        defaultMessage: 'Policy Expiration',
    },
    RequestedEffectiveDate: {
        id: 'policycommon.component.policy.Requested Coverage Effective Date',
        defaultMessage: 'Requested Coverage Effective Date',
    },
    RequestedExpirationDate: {
        id: 'policycommon.component.policy.Requested Coverage Expiration Date',
        defaultMessage: 'Requested Coverage Expiration Date',
    },
    PolicyType: {
        id: 'policycommon.policy-details.Policy Type',
        defaultMessage: 'Policy Type',
    },
    CoverageForm: {
        id: 'policycommon.policy-details.CoverageForm',
        defaultMessage: 'Coverage Form',
    },
    PolicyAddres: {
        id: 'policycommon.component.policy-details.Policy Address',
        defaultMessage: 'Policy Address',
    },
    TotalPremium: {
        id: 'policycommon.component.policy-details.Total Premium',
        defaultMessage: 'Total Premium',
    },
    TaxesAndFees: {
        id: 'policycommon.component.policy-details.Taxes and Fees',
        defaultMessage: 'Taxes and Fees',
    },
    TotalCost: {
        id: 'policycommon.component.policy-details.Total Cost',
        defaultMessage: 'Total Cost',
    },
    details: {
        id: 'policycommon.component.policy-details.Details',
        defaultMessage: 'Details',
    },
    premium: {
        id: 'policycommon.component.policy-details.Premium',
        defaultMessage: 'Premium',
    },
    status: {
        id: 'policycommon.component.policy.Status',
        defaultMessage: 'Status',
    },
    policyStatus: {
        id: 'policycommon.component.policy.Policy Status',
        defaultMessage: 'Policy Status',
    },
});
